var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    fill: "#A8A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI QUIZ BOOSTER",
    clipPath: "url(#clip0_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    transform: "translate(-453 -2224)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64",
    opacity: 0.2,
    filter: "url(#filter0_f_13_7334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.5,
    cy: 328.5,
    rx: 374.5,
    ry: 395.5,
    transform: "rotate(90 481.5 328.5)",
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 237857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    filter: "url(#filter1_d_13_7334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: 547.19,
    height: 265.77,
    rx: 19,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "span.lqd-bg-layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -40,
    width: 547.19,
    height: 265.76,
    rx: 19,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip1_13_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 0H3.5C1.70817 0 0.25 1.45817 0.25 3.25V26H19.75V3.25C19.75 1.45817 18.2918 0 16.5 0ZM17.5833 23.8333H2.41667V3.25C2.41667 2.652 2.902 2.16667 3.5 2.16667H16.5C17.098 2.16667 17.5833 2.652 17.5833 3.25V23.8333ZM4.58333 5.41667H15.4167V7.58333H4.58333V5.41667ZM4.58333 10.8333H15.4167V13H4.58333V10.8333ZM4.58333 16.25H10V18.4167H4.58333V16.25Z",
    fill: "url(#paint0_linear_13_7334)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13_7334",
    x: -318.1,
    y: -450.1,
    width: 1599.2,
    height: 1557.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 202.05,
    result: "effect1_foregroundBlur_13_7334"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_7334",
    x: -104,
    y: -80,
    width: 635.189,
    height: 353.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.341176 0 0 0 0 0.729412 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_7334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_7334",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_7334",
    x1: 0.25,
    y1: 13,
    x2: 19.75,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#7B6BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 8804,
    fill: "white",
    transform: "translate(-453 -2224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_7334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Img);
export default __webpack_public_path__ + "static/media/card1Img.6a9f9ea15224462c02eb6e97c0c45662.svg";
export { ForwardRef as ReactComponent };